import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SessionStore} from './session.store';
import {tap} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';
import {resetStores} from '@datorama/akita';
import {Router} from '@angular/router';
import {CancelConfirmHelperService} from '../../../common/gaurds/cancel-confirm/cancel-confirm-helper.service';
import {User} from '../user/user.model';
import {GooglePlacesUtil} from '../../../shared/utils/google-places-util';

@Injectable({providedIn: 'root'})
export class SessionService {

  constructor(private sessionStore: SessionStore,
              private httpClient: HttpClient,
              private router: Router,
              private cancelConfirmHelper: CancelConfirmHelperService,
              private googlePlacesUtil: GooglePlacesUtil) {
  }

  login(credentials: { username, password }) {
    const url = `${environment.apiUrl}/user/authenticate/v2`;
    const authToken = btoa(credentials.username + ':' + credentials.password);

    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');
    // .set('Authorization', 'Basic ' + authToken);

    const body = {
      username: credentials.username,
      password: credentials.password
    };

    return this.httpClient.post<any>(url, body, {headers}).pipe(
      tap(currentUser => {
        // currentUser = JwtResponse {token: string, user: User}
        // console.log('currentUser: ', currentUser);
        this.sessionStore.login({
          user: currentUser,
          name: 'Session',
          token: authToken,
          latitude: undefined,
          longitude: undefined,
        });
        this.getLocation();
        this.routeHome();
      }, () => {
        console.log('catching in session.service');
      })
    );
  }

  // refresh user details
  refreshUser() {
    const url = `${environment.apiUrl}/user/authenticate`;

    return this.httpClient.get<any>(url).pipe(
      tap(currentUser => {
        this.sessionStore.updateUser(currentUser);
      }, () => {
        console.log('catching in session.service');
      })
    );
  }

  routeHome() {
    const user = this.sessionStore.getValue().user;
    if (user.roles.includes('ROLE_HUB')) {
      this.router.navigateByUrl(`/admin/dashboard`);
      //   if (!user.funderId) {
      //     this.router.navigateByUrl('/funder-profile/profile/new');
      //   } else if (user.funderId && !user.isSimSubmitted) {
      //     this.router.navigateByUrl(`/social-investment-menu/${user.funderId}`);
      //   } else {
      //     this.router.navigateByUrl('/investor/dashboard');
      //   }
    } else if (user.roles.includes('ROLE_ORGANISATION')) {
      // see organisation.guard.ts and organisation-authentication.guard.ts
      this.router.navigateByUrl(`/organisation/dashboard`);
      //   if (!user.organisationId) {
      //     this.router.navigateByUrl('/org-profile/profile/new');
      //   } else if (user.organisationId && !user.isCapacitySpectrumSubmitted) {
      //     this.router.navigateByUrl(`/capacity-spectrum/edit/${user.organisationId}`);
      //   } else if (user.organisationId && user.isCapacitySpectrumSubmitted && !user.serviceMatrixId) {
      //     this.router.navigateByUrl(`/service-matrix/edit/${user.organisationId}`);
      //   } else {
      //     this.router.navigateByUrl('/implementer/dashboard');
      //   }
    } else if (user.roles.includes('ROLE_FACILITATOR')) {
      this.router.navigateByUrl('/facilitator/dashboard');
    }
  }

  logout() {
    this.cancelConfirmHelper.isLoggingOut = true;
    if (this.canLogOut()) {
      this.sessionStore.logout();
      resetStores();
      this.cancelConfirmHelper.isLoggingOut = false;
    }
  }

  setOrgIdOnUser(id: number) {
    this.sessionStore.setOrgIdOnUser(id);
  }

  setOrgStatusOnUser(status: string) {
    this.sessionStore.setOrgStatusOnUser(status);
  }

  resetToken(password: string) {
    this.sessionStore.resetToken(password);
  }

  impersonate(impersonatingUser: string) {
    const url = `${environment.apiUrl}/impersonate?username=${impersonatingUser}`;

    return this.httpClient.post<any>(url, undefined).pipe(
      tap((user: User) => {
        this.sessionStore.updateUser(user);
        // this.sessionStore.resetToken(user.password);
        // this.authenticate().subscribe(user1 => {
        //   console.log(user1);
        // });
      })
    );
  }

  unImpersonate() {
    const url = `${environment.apiUrl}/user/exit-impersonation`;

    return this.httpClient.post<any>(url, undefined).pipe(
      tap((user: User) => {
        this.sessionStore.updateUser(user);
        // this.sessionStore.resetToken(user.password);
      })
    );
  }

  canLogOut(): boolean {
    if (this.cancelConfirmHelper.mustConfirmLogout) {
      return this.cancelConfirmHelper.hasConfirmedCancel;
    } else {
      return true;
    }
  }

  private getLocation() {
    this.googlePlacesUtil.getLocation((latitude: number, longitude: number) =>
      this.sessionStore.updateGps(latitude, longitude)
    );
  }
}

